import { VehicleRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * updateVehicleByCustomerAndDepartment - Function that updates on database an existing vehicle by id  
 * /vehicles/{id} 
 * method PUT  
 * @async-function
 */
const updateVehicleByCustomerAndDepartment = async (token: string, id: number, model: VehicleRequestType) => {
    const response = await api.put(
        `/vehicles/${id}`, { ...model }, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default updateVehicleByCustomerAndDepartment;